export default __webpack_public_path__ + "static/media/tabuleiro.1ad6b287.webp";